import {
  availabilityCriteriaChange,
  availabilityCustomerChange,
  availabilityCustomerRQ,
  availabilityFetch,
  staggerAvailabilityFetch
} from '../actions/AvailabilityActions';
import {connect} from 'react-redux';
import SearchBarComponent from "../components/SearchBarComponent";

const mapStateToProps = state => {
  return {
   criteria : state.availabilityReducer.criteria,
   customer_key : state.availabilityReducer.customer_key,
   customer: state.availabilityReducer.customer,
   token: state.availabilityReducer.token
  }
};

const mapDispatchToProps = dispatch => {
  return {
    onCheckAvailClick : (criteria, api_url, token) => {
      // dispatch(availabilityFetch(criteria, api_url, token))
      dispatch(staggerAvailabilityFetch(criteria, api_url, token))
    },
    onCriteriaChange : criteria => {
      dispatch(availabilityCriteriaChange(criteria))
    },
    onCustomerRequest : () => {
      dispatch(availabilityCustomerRQ())
    },
    onCustomerChange : (customer, token) => {
      dispatch(availabilityCustomerChange(customer, token))
    }
  }
};

const SearchBar = connect(mapStateToProps, mapDispatchToProps) (SearchBarComponent);

export default SearchBar;


// WEBPACK FOOTER //
// ./src/containers/SearchBar.js